import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getDisplayName from 'react-display-name';

export type WithProvisioning = {
  provisioningInProgress?: boolean;
};

export const withProvisioning =
  (ProvisioningComponent: React.ComponentType<WithProvisioning>) =>
  <P extends WithProvisioning>(WrappedComponent: React.ComponentType<P>) => {
    const WithProvisioningComponent = (props: P) =>
      props.provisioningInProgress ? (
        <ProvisioningComponent {...props} />
      ) : (
        <WrappedComponent {...props} />
      );
    WithProvisioningComponent.displayName = `withProvisioning(${getDisplayName(WrappedComponent)})`;

    hoistNonReactStatics(WithProvisioningComponent, WrappedComponent);

    return WithProvisioningComponent;
  };
